'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

//  ----------  CODE EXAMPLES  ----------------------------

var CodeTabPane = _react2['default'].createClass({
    displayName: 'CodeTabPane',


    propTypes: {
        languageName: _react2['default'].PropTypes.string.isRequired,
        codeStringLines: _react2['default'].PropTypes.array.isRequired,
        codeClassNames: _react2['default'].PropTypes.string
    },

    getDefaultProps: function getDefaultProps() {
        return {
            'codeClassNames': ''
        };
    },

    render: function render() {

        var classes = (0, _classnames2['default'])('m-code-example', this.props.languageName.replace(/\#|\./g, ''));
        var preClasses = (0, _classnames2['default'])('m-code-example--code', 'prettyprint', this.props.codeClassNames);

        return _jsx('div', {
            className: classes
        }, void 0, _jsx('pre', {
            className: preClasses
        }, void 0, this.props.codeStringLines.join("\n").replace(/\&quot\;/g, '"')));
    }
});

module.exports = CodeTabPane;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api-docs/code-tab-pane.jsx
 ** module id = 732
 ** module chunks = 0
 **/